module.exports = __webpack_public_path__ + "assets/img/1361587607270_.pic_hd.13faeb21.jpg";